// extracted by mini-css-extract-plugin
export default {"wrapper":"RY-z","boldPrefix":"SY-z","link":"TY-z","message":"UY-z","image":"VY-z"};